import { useCallback, useEffect, useState } from 'react';

function readSeen(key) {
  try {
    return localStorage.getItem(key) === 'seen';
  } catch {
    return false;
  }
}

function rememberSeen(key) {
  try {
    localStorage.setItem(key, 'seen');
  } catch {}
}

export function useAnalyticsDiscovery(user, enabled) {
  const owner = user
    ? `${window.location.origin}:${user.data_loc || ''}:${user.id}`
    : '';
  const storageKey = `analytics.discovery.v1:${owner}`;
  const [discovery, setDiscovery] = useState(() => ({
    owner,
    seen: readSeen(storageKey),
  }));

  const markVisited = useCallback(() => {
    if (!enabled || !owner) return;
    rememberSeen(storageKey);
    setDiscovery({ owner, seen: true });
  }, [enabled, owner, storageKey]);

  useEffect(() => {
    if (!enabled || !owner) return;
    setDiscovery({ owner, seen: readSeen(storageKey) });
    function syncStorage(event) {
      if (event.key === storageKey && event.newValue === 'seen') {
        setDiscovery({ owner, seen: true });
      }
    }
    window.addEventListener('storage', syncStorage);
    return () => {
      window.removeEventListener('storage', syncStorage);
    };
  }, [enabled, owner, storageKey]);

  return {
    isNew: Boolean(
      enabled &&
      owner &&
      !(discovery.owner === owner ? discovery.seen : readSeen(storageKey)),
    ),
    markVisited,
  };
}
